import { useCartFreeIntroSessionGuard } from './hooks/useCartFreeIntroSessionGuard'

export const TherapistCartProviderGuards = () => {
  useCartFreeIntroSessionGuard()

  return null
}
